<template>
    <div class="row" v-if="doneBackendLoading && !productNotFind">
        <div class="col-md-4">
            <h6>{{ $t('product_detail_main_image') }}</h6>
            <div>
                <div style="position: relative;display: inline-block;">
                    <img :src="createImageSrc(mainImageSrc.src)" alt="mainImage" style="height: 30vh;border: grey 3px solid" @click="clickOnImage(createImageSrc(mainImageSrc.src))">
                    <button class="btn" style="position: absolute;top: 0;right: 0;border-radius: 50%" @click="deleteProductImage(mainImageSrc.id)">X</button>
                </div>
            </div>
            <div class="card card-body" style="margin: 3px">
                <p>{{ $t('product_detail_upload_main_image') }}
                    <input class="form-control" type="file" name="uploadMainImage" id="uploadMainImage"
                           accept=".jpg, .jpeg, .png, .gif" @change="uploadMainImage($event)">
                </p>
            </div>
            <hr>
            <h6>{{ $t('product_detail_other_image') }}</h6>
            <div v-if="otherImagesSrc.length > 0">
                <div style="position: relative;display: inline-block;margin: 3px" v-for="(value, key) in otherImagesSrc">
                    <img :src="createImageSrc(value.src)" alt="otherImages" style="height: 15vh;border: grey 2px solid" @click="clickOnImage(createImageSrc(value.src))">
                    <button class="btn" style="position: absolute;top: 0;right: 0;border-radius: 50%" @click="deleteProductImage(value.id)">X</button>
                </div>
            </div>
            <div class="card card-body" style="margin: 3px">
                <p>{{ $t('product_detail_upload_other_image') }}
                <input class="form-control" type="file" name="uploadOtherImage" id="uploadOtherImage"
                       multiple="multiple"  accept=".jpg, .jpeg, .png, .gif" @change="uploadOtherImage($event)">
                </p>
            </div>

            <!--Custom fields here-->
        </div>
        <div class="col-md-8" style="text-align: left">
            <div id="errorDetailList" style="margin: 5px"></div>
            <label for="outcode">{{ $t('product_outCode') }}</label>
            <input type="text" class="form-control" id="outcode" name="outcode" required="" v-model="outCode">
            <label for="innercode">{{ $t('product_innerCode') }}</label>
            <input type="text" class="form-control" id="innercode" name="innercode" v-model="innerCode">
            <label for="pdtnameen">{{ $t('product_product_en') }}</label>
            <input type="text" class="form-control" id="pdtnameen" name="pdtnameen" v-model="name_en">
            <label for="pdtnamech">{{ $t('product_product_zh') }}</label>
            <input type="text" class="form-control" id="pdtnamech" name="pdtnamech" v-model="name_zh">

            <div class="row">
                <div class="col-md-6">
                    <label>{{ $t('product_category') }}</label>
                    <Multiselect
                        v-model="categoryID"
                        :options="categoryList"
                        mode="single"
                        :create-option="true"
                        :can-clear=true
                        :searchable="true"
                        :placeholder="this.$t('product_search_category') + ' (' + this.categoryList.length + ')'"
                    />
                </div>
                <div class="col-md-6">
                    <label>{{ $t('product_brand') }}</label>
                    <Multiselect
                        v-model="brandID"
                        :options="brandList"
                        mode="single"
                        :create-option="true"
                        :can-clear=true
                        :searchable="true"
                        :placeholder="this.$t('product_search_brand') + ' (' + this.brandList.length + ')'"
                    />
                </div>
            </div>

            <div class="row">
                <div class="col-md-6">
                    <label>{{ $t('product_size_gp') }}</label>
                    <Multiselect
                        v-model="sizeID"
                        :options="sizeList"
                        mode="single"
                        :create-option="true"
                        :can-clear=true
                        :searchable="true"
                        :placeholder="this.$t('product_search_size') + ' (' + this.sizeList.length + ')'"
                    />
                </div>
                <div class="col-md-6">
                    <label>{{ $t('product_size_detail') }}</label>
                    <Multiselect
                        v-model="sizeDetailID"
                        :options="sizeDetailList"
                        mode="single"
                        :create-option="true"
                        :can-clear=true
                        :searchable="true"
                        :placeholder="this.$t('product_search_size_detail') + ' (' + this.sizeDetailList.length + ')'"
                    />
                </div>
            </div>

            <div class="row">
                <div class="col-md-6">
                    <label for="size_remarks">{{ $t('product_size_remarks') }}</label>
                    <input type="text" class="form-control" id="size_remarks" name="size" v-model="size_remarks">
                </div>
                <div class="col-md-6">
                    <label for="min_stock">{{ $t('product_min_stock') }}</label>
                    <input type="text" class="form-control" id="min_stock" name="min_stock" v-model="min_stock">
                </div>
            </div>

            <div class="row">
                <div class="col-md-6">
                    <label>{{ $t('product_color') }}</label>
                    <Multiselect
                        v-model="colorID"
                        :options="colorList"
                        mode="single"
                        :create-option="true"
                        :can-clear=true
                        :searchable="true"
                        :placeholder="this.$t('product_search_color') + ' (' + this.colorList.length + ')'"
                    />
                </div>
                <div class="col-md-6">
                    <label>{{ $t('product_material') }}</label>
                    <Multiselect
                        v-model="materialID"
                        :options="materialList"
                        mode="single"
                        :create-option="true"
                        :can-clear=true
                        :searchable="true"
                        :placeholder="this.$t('product_search_material') + ' (' + this.materialList.length + ')'"
                    />
                </div>
            </div>

            <div class="row">
                <datalist id="wunits">
                    <option value="g"></option>
                    <option value="kg"></option>
                </datalist>
                <div class="col-md-6">
                    <label for="nw">{{ $t('product_net_weight') }}</label>
                    <input type="text" class="form-control" id="nw" list="wunits" name="nw" v-model="net_weight">
                </div>
                <div class="col-md-6">
                    <label for="gw">{{ $t('product_gross_weight') }}</label>
                    <input type="text" class="form-control" id="gw" list="wunits" name="gw" v-model="gross_weight">
                </div>
            </div>

            <!--packing -->
            <div class="row">
                <div class="col-md-6">
                    <label for="in_pack">{{ $t('product_in_pack') }}</label>
                    <div class="row g-0">
                        <div class="col-4">
                            <input type="text" class="form-control" id="in_pack" name="in_pack" v-model="in_pack">
                        </div>
                        <div class="col-4">
                            <Multiselect
                                v-model="inUnit1ID"
                                :options="unitList"
                                mode="single"
                                :create-option="true"
                                :can-clear=true
                                :searchable="true"
                                :placeholder="this.$t('product_unit') + ' (' + this.unitList.length + ')'"
                            />
                        </div>
                        <div class="col-4">
                            <Multiselect
                                v-model="inUnit2ID"
                                :options="unitList"
                                mode="single"
                                :create-option="true"
                                :can-clear=true
                                :searchable="true"
                                :placeholder="this.$t('product_unit') + ' (' + this.unitList.length + ')'"
                            />
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <label for="out_pack">{{ $t('product_out_pack') }}</label>
                    <div class="row g-0">
                        <div class="col-4">
                            <input type="text" class="form-control" id="out_pack" name="out_pack" v-model="out_pack">
                        </div>
                        <div class="col-4">
                            <Multiselect
                                v-model="outUnit1ID"
                                :options="unitList"
                                mode="single"
                                :create-option="true"
                                :can-clear=true
                                :searchable="true"
                                :placeholder="this.$t('product_unit') + ' (' + this.unitList.length + ')'"
                            />
                        </div>
                        <div class="col-4">
                            <Multiselect
                                v-model="outUnit2ID"
                                :options="unitList"
                                mode="single"
                                :create-option="true"
                                :can-clear=true
                                :searchable="true"
                                :placeholder="this.$t('product_unit') + ' (' + this.unitList.length + ')'"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <!--L,W,H -->
            <div class="row">
                <datalist id="sunits">
                    <option value="inch"></option>
                    <option value="cm"></option>
                    <option value="mm"></option>
                </datalist>
                <div class="col-md-6">
                    <label>{{ $t('product_in_size') }}</label>
                    <div class="input-group">
                        <input type="text" class="form-control" id="in_size_length" name="in_size_length" v-model="in_size_length">
                        <input type="text" class="form-control" id="in_size_width" name="in_size_width" v-model="in_size_width">
                        <input type="text" class="form-control" id="in_size_height" name="in_size_height" v-model="in_size_height">
                    </div>
                </div>
                <div class="col-md-6">
                    <label>{{ $t('product_out_size') }}</label>
                    <div class="input-group">
                        <input type="text" class="form-control" id="out_size_length" name="out_size_length" v-model="out_size_length">
                        <input type="text" class="form-control" id="out_size_width" name="out_size_width" v-model="out_size_width">
                        <input type="text" class="form-control" id="out_size_height" name="out_size_height" v-model="out_size_height">
                    </div>
                </div>
            </div>

            <label for="remarks">{{ $t('product_remarks') }}</label>
            <input type="text" class="form-control" id="remarks" name="remarks" v-model="remarks">

            <label for="remarks">{{ $t('product_flag') }}</label>
            <select v-model="productFlag" class="form-select">
                <option value="1">{{ $t('common_show') }}</option>
                <option value="0">{{ $t('common_hide') }}</option>
            </select>
        </div>
    </div>
    <div v-if="doneBackendLoading && !productNotFind">
        <button class="btn btn-primary" style="margin: 10px;width: 200px" @click="uploadToServer">
            {{ $t('common_save') }}
        </button>
    </div>

    <div v-if="doneBackendLoading && productNotFind">
        <h3 style="color: red;">{{ $t('error_not_found') }}</h3>
    </div>

    <h5 v-if="!doneBackendLoading">{{ $t('common_loading') }}</h5>

    <vue-easy-lightbox
        :visible="showPopUpImageDetails"
        :imgs="thisImageSrc"
        :index="0"
        :zoomScale=1
        @hide="showPopUpImageDetails = false">
    </vue-easy-lightbox>

</template>

<script>
import Multiselect from "@vueform/multiselect";
import VueEasyLightbox from "vue-easy-lightbox/external-css";

export default {
    name: "ProductSingleView",
    components: {
        Multiselect,
        VueEasyLightbox,
    },
    props:{
        getOutCode: '',
        getFlag: '',
    },
    data() {
        return{
            doneBackendLoading: false,
            productNotFind: false,

            // pop up
            showPopUpImageDetails: false,
            thisImageSrc: '',

            // Product Filter
            // *** ALL ID will be place as value, cuz I can update to server as excel import
            categoryID: '',
            categoryList: [],
            brandID: '',
            brandList: [],
            sizeID: '',
            sizeList: [],
            sizeDetailID: '',
            sizeDetailList: [],
            colorID: '',
            colorList: [],
            materialID: '',
            materialList: '',
            unitList: [],

            //product Data
            productID: 0,
            outCode: '',
            innerCode: '',
            name_en: '',
            name_zh: '',
            size_remarks: '',
            remarks: '',
            in_pack: '',
            inUnit1ID: '',
            inUnit2ID: '',
            out_pack: '',
            outUnit1ID: '',
            outUnit2ID: '',
            min_stock: '',
            in_size_length: '',
            in_size_width: '',
            in_size_height: '',
            out_size_length: '',
            out_size_width: '',
            out_size_height: '',
            net_weight: '',
            gross_weight: '',
            productFlag: '',

            // product Images
            // main Image (The first item in the list)
            mainImageSrc: '',
            otherImagesSrc: [],
        }
    },
    mounted() {
         this.getBackendData()
    },
    methods: {
        async uploadToServer(){
            // clear error records
            document.getElementById('errorDetailList').innerHTML = ""

            // ******* Read me *******//
            // Size Details is using a special case then others
            // Size Details will use id as value, readable data as label
            // So I need to convert the sizeDetailID back to readable data to send back server pretend as an Excel import

            if(Number.isInteger(this.sizeDetailID)){
                this.sizeDetailID = this.sizeDetailList.filter(a => a.value === this.sizeDetailID)[0].size_detail
            }

            let data = {
                "id": this.productID,
                "outCode": this.outCode,
                "innerCode": this.innerCode,
                "category": this.categoryID,
                "brand": this.brandID,
                "name_en": this.name_en,
                "name_zh": this.name_zh,
                "size": this.sizeID,
                "size_detail": this.sizeDetailID,
                "size_remarks": this.size_remarks,
                "color": this.colorID,
                "material": this.materialID,
                "remarks": this.remarks,
                "in_pack": this.in_pack,
                "in_unit1": this.inUnit1ID,
                "in_unit2": this.inUnit2ID,
                "out_pack": this.out_pack,
                "out_unit1": this.outUnit1ID,
                "out_unit2": this.outUnit2ID,
                "min_stock": this.min_stock,
                "in_size_length": this.in_size_length,
                "in_size_width": this.in_size_width,
                "in_size_height": this.in_size_height,
                "out_size_length": this.out_size_length,
                "out_size_width": this.out_size_width,
                "out_size_height": this.out_size_height,
                "net_weight": this.net_weight,
                "gross_weight": this.gross_weight,
                "flag": this.productFlag,
            }
            try{
                if(this.sizeDetailList.filter(a => a.size_detail === this.sizeDetailID)[0].value !== undefined){
                    this.sizeDetailID = this.sizeDetailList.filter(a => a.size_detail === this.sizeDetailID)[0].value
                }
            }catch (e){
                // pass
            }

            // console.log(data)

            await this.$mainApi.post('api/product/confirm/', {
                "data": [data]
            })
                .then(async response => {
                    if (response.data.status === 80) {
                        if (response.data.errors.errors_details.length > 0) {
                            // Have Errors
                            let parent = document.getElementById('errorDetailList')
                            let getErrorList = response.data.errors.errors_details
                            for (let i = 0; i < getErrorList.length; i++) {
                                let htmlContent = await this.$serverErrorReturn(getErrorList[i]['errors'])
                                let subParent =
                                    "<div class='row' style='background-color: #d4d5e5;border: solid grey 1px;border-radius: 15px'>" +
                                    "<div class='col-3 my-auto'>" +
                                    "<h4><strong>" + this.$t('error_warning') + "</strong></h4>" +
                                    "</div>" +
                                    "<div class='col-9'>" + htmlContent + "</div>" +
                                    "</div><br>"
                                parent.innerHTML += subParent
                            }
                            this.$toast.error(this.$t('error_error_happen'))
                        } else {
                            this.$toast.success(this.$t('common_success'))
                            this.$router.go(0)
                        }
                    }
                })
        },
        getImgUrl(file){
            return URL.createObjectURL(file)
        },
        async uploadOtherImage(e){
            let errorList = []
            for(let i=0;i<e.target.files.length;i++) {
                let thisImage = e.target.files.item(i)
                let thisImageName = e.target.files.item(i).name
                let thisImageOutCode = this.outCode

                let formData = new FormData()
                formData.append('id', i+1)
                formData.append('outCode', thisImageOutCode)
                formData.append('fileName', thisImageName)
                formData.append('image_url', this.getImgUrl(thisImage))
                formData.append('image', thisImage)
                await this.$mainApi.post('api/product/upload-images/', formData, {
                    headers: {
                        "content-type": "multipart/form-data"
                    }
                })
                    .then(response => {
                        if(response.data.status === 80){
                            // pass
                        }else{
                            errorList.push({
                                "id": i+1,
                                "errors": response.data.details
                            })
                        }
                    })
            }
            if(errorList.length > 0){
                let getErrorList = errorList
                let mainContent = ""
                for (let i = 0; i < getErrorList.length; i++) {
                    let htmlContent = await this.$serverErrorReturn(getErrorList[i]['errors']['error'])
                    let subParent =
                        "<div class='row' style='background-color: #d4d5e5;border: solid grey 1px;border-radius: 15px'>" +
                        "<div class='col-3 my-auto'>" +
                        "<h4><strong>" + this.$t('common_row') + " " + getErrorList[i]['id'] + "</strong></h4>" +
                        "</div>" +
                        "<div class='col-9'>" + htmlContent + "</div>" +
                        "</div><br>"
                    mainContent += subParent
                }
                this.$swal.fire({
                    "title": this.$t('error_warning'),
                    "icon": "warning",
                    "html": "<div style='margin: 5%'>" + mainContent + "</div>"
                }).then(async (result) => {
                    if (result.isConfirmed) {
                        await this.reloadProductImage()
                    }
                })
            }else{
                await this.reloadProductImage()
            }
        },
        async uploadMainImage(e){
            for(let i=0;i<e.target.files.length;i++){
                let thisImage = e.target.files.item(i)
                let thisImageName = e.target.files.item(i).name
                let thisImageOutCode = this.outCode

                if(this.mainImageSrc.id === 0){
                    // No Image -> Have new Image
                    // Go to Upload New Image
                    let formData = new FormData()
                    formData.append('id', 1)
                    formData.append('outCode', thisImageOutCode)
                    formData.append('fileName', thisImageName)
                    formData.append('image_url', this.getImgUrl(thisImage))
                    formData.append('image', thisImage)
                    await this.$mainApi.post('api/product/upload-images/', formData, {
                        headers: {
                            "content-type": "multipart/form-data"
                        }
                    })
                        .then(response => {
                            if(response.data.status === 80){
                                this.reloadProductImage()
                            }else{
                                this.$swal.fire({
                                    "title": this.$t('error_warning'),
                                    "icon": "warning",
                                    "text": JSON.stringify(response.data.details),
                                })
                            }
                        })

                }else{
                    // Have image -> Update Image
                    // Go to Update Image
                    let formData = new FormData()
                    formData.append('id', this.mainImageSrc.id)
                    formData.append('image', thisImage)
                    await this.$mainApi.put('api/product/upload-images/', formData, {
                        headers: {
                            "content-type": "multipart/form-data"
                        }
                    })
                        .then(response => {
                            if(response.data.status === 80){
                                this.reloadProductImage()
                            }else{
                                this.$swal.fire({
                                    "title": this.$t('error_warning'),
                                    "icon": "warning",
                                    "text": JSON.stringify(response.data.details),
                                })
                            }
                        })
                }
            }
        },
        async reloadProductImage(){
            this.$store.commit('setIsTopLoading', true)
            await this.$mainApi.get(`api/product?code=${this.outCode}`)
                .then(response => {
                    if(response.data.status === 80){
                        this.updateImageView(response.data.details.images_url)
                    }
                })
            this.$store.commit('setIsTopLoading', false)
        },
        async deleteProductImage(getImageID){
            this.$swal.fire({
                "title": this.$t('error_warning'),
                "text": this.$t('common_confirm_action_delete')
            }).then(async (result) => {
                if (result.isConfirmed) {
                    await this.$mainApi.delete(`api/product/upload-images?id=${getImageID}`)
                        .then(response => {
                            if(response.data.status === 80){
                                this.$toast.success(this.$t('common_success'))
                                this.reloadProductImage()
                            }
                        })
                }
            })
        },
        createImageSrc(imgSrc){
            return imgSrc + "?" + new Date().getTime()
        },
        clickOnImage(imgSrc){
            this.showPopUpImageDetails = true
            this.thisImageSrc = imgSrc
        },
        updateImageView(images){
            // clear Old Data
            this.otherImagesSrc = []
            this.mainImageSrc = ''

            // Images
            if(images.length > 0){
                // have images
                for(let i=0;i<images.length;i++){
                    if(i === 0){
                        // First Loop
                        this.mainImageSrc = {
                            "id": images[i].id,
                            "src": this.$store.state.serverIp + images[i].img_path
                        }
                    }else{
                        let this_image = {
                            "id": images[i].id,
                            "src": this.$store.state.serverIp + images[i].img_path
                        }
                        this.otherImagesSrc.push(this_image)
                    }
                }
            }else{
                this.mainImageSrc = {
                    "id": 0,
                    "src": this.$store.state.serverIp + this.$store.state.serverMediaNoImage
                }
            }
        },
        async getBackendData(){
            this.$store.commit('setIsTopLoading', true)
            // 1. Get Filter Data
            await this.$mainApi.get('api/product/filter/')
                .then(response => {
                    if(response.data.status === 80){
                        // listToLoop = [sqlForCategory, sqlForBrand, sqlForSize, sqlForSizeDetails, sqlForColor, sqlForMaterial]
                        this.categoryList = response.data.details[0]["1"]
                        this.brandList = response.data.details[1]["2"]
                        this.sizeList = response.data.details[2]["3"]
                        this.sizeDetailList = response.data.details[3]["4"]
                        this.colorList = response.data.details[4]["5"]
                        this.materialList = response.data.details[5]["6"]
                        this.unitList = response.data.details[6]["7"]
                    }
                })
            if(this.getFlag === "add"){
                // Add Item, get Only other details
                this.outCode = ""
                this.mainImageSrc = {
                    "id": 0,
                    "src": this.$store.state.serverIp + this.$store.state.serverMediaNoImage
                }
            }else{
                this.outCode = this.getOutCode
                await this.$mainApi.get(`api/product?code=${this.outCode}`)
                    .then(response => {
                        if(response.data.status === 80){
                            if(response.data.details.product.length > 0){
                                let product = response.data.details.product[0]
                                this.productID = product.id
                                this.innerCode = product.innerCode
                                this.name_en = product.name_en
                                this.name_zh = product.name_zh
                                // this.categoryID = product.category_id
                                this.categoryID = product.category_name
                                // this.brandID = product.brand_id
                                this.brandID = product.brand_name
                                // this.sizeID = product.size_group_id
                                this.sizeID = product.size_group
                                this.sizeDetailID = product.size_detail_id
                                // this.sizeDetailID = product.size_detail
                                this.size_remarks = product.size_remarks
                                // this.colorID = product.color_id
                                this.colorID = product.color
                                // this.materialID = product.material_id
                                this.materialID = product.material
                                this.remarks = product.remarks
                                this.in_pack = product.in_pack
                                this.out_pack = product.out_pack
                                // this.inUnit1ID = product.in_unit1_id
                                // this.inUnit2ID = product.in_unit2_id
                                // this.outUnit1ID = product.out_unit1_id
                                // this.outUnit2ID = product.out_unit2_id
                                this.inUnit1ID = product.in_unit1
                                this.inUnit2ID = product.in_unit2
                                this.outUnit1ID = product.out_unit1
                                this.outUnit2ID = product.out_unit2
                                this.min_stock = product.min_stock
                                this.in_size_length = product.in_size_length
                                this.in_size_width = product.in_size_width
                                this.in_size_height = product.in_size_height
                                this.out_size_length = product.out_size_length
                                this.out_size_width = product.out_size_width
                                this.out_size_height = product.out_size_height
                                this.net_weight = product.net_weight
                                this.gross_weight = product.gross_weight
                                this.productFlag = product.flag

                                // Images
                                this.updateImageView(response.data.details.images_url)
                            }else{
                                this.productNotFind = true
                            }
                        }
                    })
            }
            this.$store.commit('setIsTopLoading', false)
            this.doneBackendLoading = true
        }
    }
}
</script>

<style scoped>

img{
    cursor: pointer;
}

</style>
